// extracted by mini-css-extract-plugin
export default {"favoritesLink":"favoritesLink___sRSL0","filledContainer":"filledContainer___ix2lg","favoriteIcon":"favoriteIcon___NXA1g","arrowIcon":"arrowIcon___hZljF","heading":"heading___u8eWW"};